export const SEO_DATA = {
  title: `Post a Job, Find the best software engineers | JobsHash`,
  description: `Get access to a pool of talented engineers who are looking for their next gig.`,
  image: `https://static.jobshash.com/default-og.png`,
};
